import NTPC from "../../images/sponsors/2022/NTPCLogo.png";
import Blend360 from "../../images/sponsors/2022/Blend360.svg";
import Sales from "../../images/sponsors/2022/Sales.svg";
import Coding from "../../images/sponsors/2022/Coding.svg";
import Techvanto from "../../images/sponsors/2022/Techvanto.png";
import KLA from "../../images/sponsors/2022/KLA.png";
import Coco from "../../images/sponsors/2022/Coco.jpeg";
import Youth from "../../images/sponsors/2022/youth.png";
import Unblended from "../../images/sponsors/2022/Unblended.png";
import MentorX from "../../images/sponsors/2022/MentorX.png";
import LIC from "../../images/sponsors/2022/LIC.png";
import Fash from "../../images/sponsors/2022/fash.png";
import Blur from "../../images/sponsors/2022/Blur.webp";
import HoverRobotix from "../../images/sponsors/2022/HoverRobotix.png";
import Xcube from "../../images/sponsors/2022/Xcube.png";
import DLink from "../../images/sponsors/2022/DLink.png";
import Noticebard from "../../images/sponsors/2022/NoticeBard.png";
import Vijaya from "../../images/sponsors/2022/Vijaya.png";
import Ease from "../../images/sponsors/2022/Ease.png";
import LogoNT from "../../images/sponsors/2022/logoNT.png";
// import ICICI from "../../images/sponsors/2022/ICICI.png";
import IODL from "../../images/sponsors/2022/servo-logo.jpg";
import Wing from "../../images/sponsors/2022/wing.jpg";
import Quert from "../../images/sponsors/2022/Quert.png";
import Remark from "../../images/sponsors/2022/Remark.png";
import SBI from "../../images/sponsors/2022/sbi.png";
import Canera from "../../images/sponsors/canera bank - Copy.png";
import Indinoir from "../../images/sponsors/2022/Indinoir Logo (2).png";
import alumni from "../../images/sponsors/2022/iith_alumni.png";
import cranberry from "../../images/sponsors/2022/cran.png";
import harbour from "../../images/sponsors/2022/harbour.png"
const Sponsors2022 = [
  {
    Name: "Coca Cola",
    Description:
      "The Coca-Cola Company is a beverage company with products sold in more than 200 countries. We seek to positively impact people’s lives and planet through water replenishment, packaging recycling, sustainable sourcing practices and carbon emissions reductions across our value chain.",
    Website: "https://www.coca-colacompany.com/",
    Linkedin: "https://www.linkedin.com/company/the-coca-cola-company/",
    Image: Coco,
    Role: "Refreshing Partner",
  },
  {
    Name: "[x]cubeLabs",
    Description:
      "[x]cube LABS helps enterprises globally with digital transformation and digital technology adoption. We take a highly collaborative approach and help solve problems across the entire digital transformation journey from ideation and strategizing to experimentation and execution",
    Website: "https://www.xcubelabs.com/",
    Linkedin:
      "https://www.linkedin.com/company/xcubelabs/?originalSubdomain=in",
    Image: Xcube,
    Role: "Digital Transformation Partner",
  },
  {
    Name: "KLA",
    Description:
      "KLA Corporation is a capital equipment company based in California. They develop industry-leading equipment and services that enable innovation throughout the electronics industry.",
    Website: "https://www.kla.com/",
    Instagram:
      "https://www.instagram.com/explore/locations/4705697/united-states/milpitas-california/kla-corporation/",
    Facebook: "https://www.facebook.com/KLAcorp/",
    Linkedin: "https://www.linkedin.com/company/klacorp/",
    Image: KLA,
    Role: "Platinum Sponsor",
  },
  {
    Name: "Salesforce",
    Role: "Futureforce Partner",
    Description:
      "Salesforce is an American cloud-based software company headquartered in San Francisco, California. It provides customer relationship management (CRM) software and applications focused on sales, customer service, marketing automation, analytics, and application development.",
    Website: "https://www.salesforce.com/in/",
    Instagram: "https://www.instagram.com/salesforce/",
    Facebook: "https://www.facebook.com/salesforce/",
    Image: Sales,
  },
  {
    Name: "TS Dairy",
    Description:
      "TSDDCF seeks to usher in an era of rural property in Telangana State through organized commercial dairying based on the principals of cooperatives. For development of village based dairy sector we integrate milk producers at village level with consumer in the urban and metropolitan markets.",
    Website: "https://tsdairy.telangana.gov.in/",
    Instagram: "https://www.instagram.com/ts_dairy_09/",
    Image: Vijaya,
    Role: "Gold sponsor",
  },
  {
    Name: "LIC",
    Role: "Gold sponsor",
    Description:
      "Life Insurance Corporation of India (abbreviated as LIC) is an Indian state-owned insurance group and investment corporation owned by the Government of India. Over 245 insurance companies and provident societies were merged to create the state-owned Life Insurance Corporation of India.",
    Website: "https://licindia.in/",
    Instagram: "https://www.instagram.com/licindiaforever/?hl=en",
    Image: LIC,
  },
  {
    Name: "NTPC",
    Role: "GOld sponsor",
    Description:
      "NTPC Limited, formerly known as National Thermal Power Corporation Limited, is an Indian Public Sector Undertaking, engaged in the business of generation of electricity and allied activities.",
    Website: "https://www.ntpc.co.in/",
    Instagram: "https://www.instagram.com/ntpclimited/?hl=en",
    Image: NTPC,
  },
  {
    Name: "Blend360",
    Role: "Data Science Partner",
    Description:
      "Blend360 is a company with strong values, a passion to work with the elite, and focus on data science. They are well known for their core capabilities to data science solutions to various companies.",
    Website: "https://www.blend360.com/",
    Linkedin: "https://www.linkedin.com/company/blend360",
    Image: Blend360,
  },
  {
    Name: "Nuetech Solar",
    Role: "Gold Sponsor",
    Description:
      "Nuetech Solar Systems Pvt. Ltd commands a rich experience in the Renewable Energy Industry having its origin in the very nascent days of Solar Thermal Business in India.",
    Website: "http://nuetechsolar.com/",
    Instagram: "https://www.instagram.com/nuetechsolarindia/",
    Facebook: "https://www.facebook.com/NuetechSolarIndia",
    Twitter: "https://twitter.com/NuetechS",
    Linkedin:
      "https://www.linkedin.com/company/nuetech-solar-systems-privite-limited",
    Image: LogoNT,
  },
  {
    Name: "IOCL",
    Role: "Gold Sponsor",
    Description:
      "Indian Oil Corporation Limited(IOCL) is a largest government owned oil corporation in the India. Indian Oil's commercial activities span the whole hydrocarbon value chain, including refining, pipeline transportation, petroleum product marketing, crude oil, natural gas, and petrochemical exploration and production.",
    Website: "https://iocl.com/",
    Instagram: "https://www.instagram.com/indianoilcorp/",
    Facebook: "https://www.facebook.com/IndianOilCorpLimited/",
    Image: IODL,
  },
  {
    Name: "Wingfotech",
    Role: "Silver Sponsor",
    Description:
      "Wingfotech is a quality certified & MSME (Government of India) recognized institute providing a comprehensive e-learning platform dedicated to developing the state of art learning techniques in the field of advanced engineering branches and high-end technology",
    Facebook: "https://www.facebook.com/wingfotech/",
    Linkedin:
      "https://www.linkedin.com/company/wingfotech/?originalSubdomain=in",
    Image: Wing,
  },
  {
    Name: "Canara bank",
    Role: "Gold sponsor",
    Description:
      "Canara Bank Limited is one of the largest public sector banks owned by the Government of India.Canara Bank occupies a premier position in the comity of Indian banks with an unbroken record of profits since its inception.",
    Website: "https://canarabank.com/",
    Instagram: "https://www.instagram.com/canarabankinsta/?hl=en",
    Image: Canera,
  },
  {
    Name: "SBI",
    Role: "Gold sponsor",
    Description:
      "State Bank of India is an Indian multinational, public sector banking and financial services statutory body.SBI provides a range of banking products through its network of branches in India and overseas",
    Website: "https://www.onlinesbi.com/",
    Instagram: "https://www.instagram.com/theofficialsbi/?hl=en",
    Image: SBI,
  },
  {
    Name: "Techvanto",
    Role: "Workshop partner",
    Description:
      "Techvanto is a leading software development company that enables disruptive startups to bridge the gap between ideas and reality with innovative software solutions. Techvanto's main goal is to create and promote breakthrough information technologies for multi-user applications.",
    Website: "https://techvanto.com/",
    Instagram: "https://www.instagram.com/techvanto_official/",
    Twitter: "https://twitter.com/techvanto",

    Facebook: "https://www.facebook.com/techvanto.official",
    Linkedin: "https://www.linkedin.com/company/techvanto",
    Image: Techvanto,
  },
  {
    Name: "Remark Skill",
    Role: "Training Partner",
    Description:
      "Think, Learn, Certify and Innovate with Remark Skill. Give your ideas a kick start by learning trending technologies. The booming internet is changing market requirements. Prepare yourself and stand out in this crowd. Your vision is Remark Skill’s vision",
    Website: "https://remarkskill.com/",

    Instagram: "https://www.instagram.com/remarkskill/",
    Image: Remark,
  },
  {
    Name: "Coding Ninjas",
    Role: "Coding Partner",
    Description:
      "Coding Ninjas was founded to bridge the knowledge gap between colleges and the industry. With faculty alumni from IIT, Stanford, IIIT, and Facebook, Coding Ninjas has a world-class teaching faculty and a cutting-edge learning platform for Coding instruction.",
    Website: "https://www.codingninjas.com/",
    Instagram: "https://www.instagram.com/coding.ninjas/",
    Facebook: "https://www.facebook.com/codingninjas/",
    Image: Coding,
  },
  {
    Name: "D-Link",
    Role: "Silver Sponsor",
    Description:
      "D-Link Corporation is a Taiwanese multinational networking equipment manufacturing corporation headquartered in Taipei, Taiwan. D-Link has over 28 years of expertise developing the highest quality networking solutions to meet the ever-changing connectivity needs for businesses of all sizes. ",
    Website: "https://www.dlink.com/",
    Instagram: "https://www.instagram.com/dlinkindia/",
    Image: DLink,
  },
  {
    Name: "Qwerty Thoughts",
    Role: "Literary Partner",
    Description:
      "Qwerty Thoughts is a social reading, book discovery, promotion and self publishing platform selling books globally, where readers can read a book with others and connect, share their experiences in real time. It makes books come alive by putting together the reading journey, experiences and knowledge of innumerable readers from different parts of the world, across cultures all inside the book.",
    Image: Quert,
  },
  {
    Name: "Hoverbotix",
    Description:
      "HoverRobotix Mobility devices are the futuristic solution to the environmental pollution problem with its Hoverboards. No matter which corner of India you belong to, we try to deliver your dream wheels at the earliest.",
    Website: "https://hoverrobotix.com/",
    Image: HoverRobotix,
    Role: "Mentor partner",
  },

  {
    Name: "MentorX",
    Description:
      "MentorX is a platform formulated by world-class visionaries who have a common vision to educate, empower, and elevate as many people as possible. MENTORx team is working with a clear objective to make people rise by providing them with essential guidance and by connecting at the grass-root level with everyone.",
    Website: "https://thementorx.com/",
    Image: MentorX,
    Role: "Robotix Partner",
  },
  {
    Name: "Unblended",
    Image: Unblended,
    Role: " Beauty Partner",
    Website: "https://unblended.in/",
    Instagram: "https://www.instagram.com/unblended_story/",
    Facebook: "https://www.facebook.com/unblended.in/",
    Description:
      "Unblended is an all women startup committed to providing customers with a wide range of products that are organic, pure and unaltered. Making luxury accessible to many.  They develop most premium and luxury products in a way that is personalised and bespoke.",
  },
  {
    Name: "NoticeBard",
    Image: Noticebard,
    Role: "Media Partner",
    Description:
      "NoticeBard was started in March 2017 as a notice-board for educational opportunities and events.NoticeBard is also, well, a bard (story-teller!) of student-related news and issues.",
    Website: "https://www.noticebard.com/",
    Linkedin: "https://in.linkedin.com/company/noticebard/",
  },
  {
    Name: "Youth Incorporated",
    Image: Youth,
    Role: "Youth Media Partner",
    Description:
      "The magazine showcases relevant information and articles on education in India and abroad. With campus reviews, student profiles, professor interviews and a strong focus on careers and entrepreneurship, the magazine aims to empower the youth in today’s competitive world. ",
  },
  {
    Name: "Blur India",
    Image: Blur,
    Role: "Beauty Partner",
    Website: "https://blurindia.com/",
    Instagram: "https://www.instagram.com/blurindia/?hl=en",
    Description:
      "Blur India makes gorgeous products with a hint of sass. The Formulas, the textures, the packaging- it's all done using inputs from our customers! Team Blur wants to create a beauty community like no other :) ",
  },
  {
    Name: "Fashion Herald",
    Image: Fash,
    Role: "Media Partner",
    Instagram: "https://www.instagram.com/fashion.herald/",
    Description:
      "FASHION HERALD is a renowned fashion magazine of Lucknow focusing on changing trends in every sphere from fashion, arts, lifestyle, food,entertainment to business and economics. They have a circulation of 128000 copies in Lucknow,Delhi, Mumbai. The magazine has readership in the elite gentry.",
  },
  {
    Name: "Indinoir",
    Image: Indinoir,
    Role: "Fragrance Partner",
    Description:
      "Indinoir makes perfumes that will make you and those around you feel good. Perfumes you can build memories with. Whether you are at work, meeting friends or just by yourself we have something for you. ",
    Website: "https://indinoir.com/",
    Instagram: "https://www.instagram.com/indinoir.store/?hl=en",
  },
  {
    Name: "Easemytrip",
    Image: Ease,
    Role: "Booking Partner",
    Description:
      "EaseMyTrip is an Indian online travel company, founded in 2008 by Nishant Pitti, Rikant Pitti, and Prashant Pitti. Headquartered in New Delhi, the company provides hotel bookings, air tickets, holiday packages, bus bookings, and white-label services.",
    Website: "https://www.easemytrip.com/",
    Instagram: "https://www.instagram.com/easemytrip/?hl=en",
  },
  {
    Name:"IITH Alumni ",
    Image: alumni,
    Role: "Major Sponsor",
    // Description:
   
    // Website: 
    // Instagram: 
  },
  {
    Name:"Cranberry Customs ",
    Image: cranberry,
    Role: "Merchandise Partner",
    // Description:
    
    Website: "https://cranberrycustoms.com/",
    // Instagram:
  },
  {
    Name:" Harbour Technologies ",
    Image: harbour,
    Role: "Workshop Partner",
    // Description:
    
    // Website: 
    // Instagram:
  },
];

export default Sponsors2022;
